import type { VFC } from 'react';
import { Spin, type SpinProps } from 'antd';

export const SpinnerBox: VFC<SpinProps> = props => (
  <div
    style={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Spin size="large" {...props} />
  </div>
);
